import axiosClient from "api/axiosClient";
import API_MAP from "constants/api";

export const appService = {
    getOneConfig: async (configCode) => {
        try {
            const res = await axiosClient.get(`${API_MAP.GET_ONE_CONFIG}?code=${configCode}`);

            return res?.data?.[0];
        } catch (error) {
            return ''
        }
    }
}